var exports = {
  "O": "TestimonialsSection__07eeeS",
  "a": "TestimonialsSection__Spacer__8Ckk9l",
};

module.exports = exports;
